import { Typography } from 'amo-styling-library'
import { useContainer } from '../../contexts/ContainerContext'
import { ContainerTable } from '../../components/containers/ContainerTable'
import type { Container } from '../../types/container'

export interface ExpectedContainersViewProps {
  onContainerClick: (container: Container) => void
}

export const ExpectedContainersView: React.FC<ExpectedContainersViewProps> = ({
  onContainerClick,
}) => {
  const { containers } = useContainer()

  return (
    <div>
      {/* Header Section */}
      <div className="flex justify-between items-center mb-16">
        <Typography variant="h2" className="text-gray-900">
          Container Informatie
        </Typography>
      </div>

      {/* Container Table */}
      <ContainerTable data={containers} onRowClick={onContainerClick} />
    </div>
  )
}
